import de from './de.json'
import en from './en.json'

const messages = { de, en }

export function getLocale () {
  return localStorage.getItem('locale') || navigator.language.slice(0, 2) || 'de'
}

export function setLocale (locale) {
  localStorage.setItem('locale', locale)
}

export function loadLocaleMessages (locale) {
  return messages[locale] || messages.de
}

export { messages }
